import React, { useState, useEffect } from 'react';
import { Menu, X, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/95 backdrop-blur-md border-b border-orange-500/20' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1 className="text-2xl font-bold text-white futuristic-text cursor-pointer"
                onClick={() => scrollToSection('hero')}>
              InSkill
            </h1>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            <div className="flex items-baseline space-x-8">
              {['Home', 'About', 'Courses', 'Projects', 'Contact'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item.toLowerCase())}
                  className="text-gray-300 hover:text-orange-500 px-3 py-2 text-sm font-medium transition-colors duration-200 glow-hover"
                >
                  {item}
                </button>
              ))}
            </div>

            <Link
              to="/skill/report"
              className="flex items-center space-x-1.5 text-xs font-semibold text-orange-400 hover:text-white bg-orange-500/10 hover:bg-orange-500 border border-orange-500/30 hover:border-orange-500 px-3.5 py-1.5 rounded-lg transition-all"
            >
              <Clock size={14} />
              <span>Work Report</span>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-3">
            <Link
              to="/skill/report"
              className="text-xs font-semibold text-orange-400 bg-orange-500/10 border border-orange-500/30 px-2.5 py-1 rounded"
            >
              Report
            </Link>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-300 hover:text-orange-500 transition-colors duration-200"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-black/95 backdrop-blur-md border-t border-orange-500/20">
              {['Home', 'About', 'Courses', 'Projects', 'Contact'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item.toLowerCase())}
                  className="text-gray-300 hover:text-orange-500 block px-3 py-2 text-base font-medium transition-colors duration-200 w-full text-left"
                >
                  {item}
                </button>
              ))}
              <Link
                to="/skill/report"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-orange-400 block px-3 py-2 text-base font-medium"
              >
                Work Report Portal (/skill/report)
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;